export const glowPlugs = [
  {
    id: 'GLO001',
    name: 'GLO001',
    description: '프론티어(프레지오공용) FRONTIER (STYLE)',
    partNumber: '11V - 0K75A-18140(A)',
    price: 45000,
    category: 'GLOW PLUG (글로우 플러그)',
    image: 'https://public.readdy.ai/ai/img_res/ce7a3b5f239e05e4530b2adcda1a407d.jpg',
    inStock: true,
    featured: false
  },
  {
    id: 'GLO002',
    name: 'GLO002',
    description: '프레지오용(프론티어공용) (PREGIO) STYLE',
    partNumber: '11V - 0K758-18140(A39J) 3,000CC(B)',
    price: 45000,
    category: 'GLOW PLUG (글로우 플러그)',
    image: 'https://readdy.ai/api/search-image?query=automotive%20glow%20plug%20diesel%20engine%20component%20on%20clean%20white%20background%20professional%20product%20photography%20high%20quality%20metal%20finish&width=400&height=400&seq=glo002&orientation=squarish',
    inStock: true,
    featured: false
  },
  {
    id: 'GLO003',
    name: 'GLO003',
    description: '테라칸용,뉴포터(T엔진) 스타렉스(STAREX) (TERACAN)(NEW-PORTER) STYLE',
    partNumber: '11V - 36710-42020',
    price: 45000,
    category: 'GLOW PLUG (글로우 플러그)',
    image: 'https://readdy.ai/api/search-image?query=automotive%20glow%20plug%20diesel%20engine%20component%20on%20clean%20white%20background%20professional%20product%20photography%20high%20quality%20metal%20finish&width=400&height=400&seq=glo003&orientation=squarish',
    inStock: true,
    featured: false
  },
  {
    id: 'GLO004',
    name: 'GLO004',
    description: '테라칸용(T엔진과공용) TERACAN (STYLE)',
    partNumber: '11V - 36710-42550',
    price: 45000,
    category: 'GLOW PLUG (글로우 플러그)',
    image: 'https://readdy.ai/api/search-image?query=automotive%20glow%20plug%20diesel%20engine%20component%20on%20clean%20white%20background%20professional%20product%20photography%20high%20quality%20metal%20finish&width=400&height=400&seq=glo004&orientation=squarish',
    inStock: true,
    featured: false
  },
  {
    id: 'GLO005',
    name: 'GLO005',
    description: '갤로퍼 언더쿨러용(T엔진공용) (GALLOPER INTERCOOLER)용',
    partNumber: '11V - 36710-42500',
    price: 45000,
    category: 'GLOW PLUG (글로우 플러그)',
    image: 'https://readdy.ai/api/search-image?query=automotive%20glow%20plug%20diesel%20engine%20component%20on%20clean%20white%20background%20professional%20product%20photography%20high%20quality%20metal%20finish&width=400&height=400&seq=glo005&orientation=squarish',
    inStock: true,
    featured: false
  },
  {
    id: 'GLO006',
    name: 'GLO006',
    description: '쏘렌토,리베로,포터2 용(CITT엔진용) 스타렉스-(커먼레일엔진용) (SORENTO)(LIBERO)(PORTER2) STYLE',
    partNumber: '11V - 36710-4A000',
    price: 45000,
    category: 'GLOW PLUG (글로우 플러그)',
    image: 'https://readdy.ai/api/search-image?query=automotive%20glow%20plug%20diesel%20engine%20component%20on%20clean%20white%20background%20professional%20product%20photography%20high%20quality%20metal%20finish&width=400&height=400&seq=glo006&orientation=squarish',
    inStock: true,
    featured: false
  },
  {
    id: 'GLO007',
    name: 'GLO007',
    description: '봉고3(BONGO3)그랜드카니발 용 (GRAND CARNLVAL) STYLE',
    partNumber: '11V - 36710-4X900',
    price: 45000,
    category: 'GLOW PLUG (글로우 플러그)',
    image: 'https://readdy.ai/api/search-image?query=automotive%20glow%20plug%20diesel%20engine%20component%20on%20clean%20white%20background%20professional%20product%20photography%20high%20quality%20metal%20finish&width=400&height=400&seq=glo007&orientation=squarish',
    inStock: true,
    featured: false
  },
  {
    id: 'GLO008',
    name: 'GLO008',
    description: '마이티2,카운티,코러스(신형) 용 (MIGHTY2Y,COUNTY)(CHORUS) STYLE',
    partNumber: '23V - 36710-45001',
    price: 45000,
    category: 'GLOW PLUG (글로우 플러그)',
    image: 'https://readdy.ai/api/search-image?query=automotive%20glow%20plug%20diesel%20engine%20component%20on%20clean%20white%20background%20professional%20product%20photography%20high%20quality%20metal%20finish&width=400&height=400&seq=glo008&orientation=squarish',
    inStock: true,
    featured: false
  },
  {
    id: 'GLO009',
    name: 'GLO009',
    description: '산타페,트라젯XG,투싼,스포티지(신형) 용 (SANTAFAE)(YUSON)(TRAJET(XG) (SPORTAGE) STYLE',
    partNumber: '11V - 36710-27010',
    price: 45000,
    category: 'GLOW PLUG (글로우 플러그)',
    image: 'https://readdy.ai/api/search-image?query=automotive%20glow%20plug%20diesel%20engine%20component%20on%20clean%20white%20background%20professional%20product%20photography%20high%20quality%20metal%20finish&width=400&height=400&seq=glo009&orientation=squarish',
    inStock: true,
    featured: false
  },
  {
    id: 'GLO010',
    name: 'GLO010',
    description: 'PORTER 2 포터2 경량 플러그 엔진 디젤(CRDI)',
    partNumber: '(11V) 15.5cm - 36710-4A710',
    price: 45000,
    category: 'GLOW PLUG (글로우 플러그)',
    image: 'https://readdy.ai/api/search-image?query=automotive%20glow%20plug%20diesel%20engine%20component%20on%20clean%20white%20background%20professional%20product%20photography%20high%20quality%20metal%20finish&width=400&height=400&seq=glo010&orientation=squarish',
    inStock: true,
    featured: false
  }
];
